/**
 * ModeratorRoute — allows access to users who are isAdmin OR isModerator.
 * Regular authenticated users (neither admin nor moderator) are redirected to dashboard.
 */
import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import firestoreService from "../../services/firestoreService";
import LoadingSpinner from "./LoadingSpinner";
import { ROUTES } from "../../utils/constants";

const ModeratorRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !user?.email) {
      setChecking(false);
      return;
    }
    firestoreService
      .getUserAccount(user.email)
      .then((account) => {
        setAllowed(account?.isAdmin === true || account?.isModerator === true);
      })
      .catch(() => setAllowed(false))
      .finally(() => setChecking(false));
  }, [isAuthenticated, user?.email]);

  if (loading || checking) {
    return (
      <div className="protected-route-loading">
        <LoadingSpinner />
        <p>Checking permissions...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.ADMIN_LOGIN} replace />;
  }

  if (!allowed) {
    return <Navigate to={ROUTES.ADMIN_DASHBOARD} replace />;
  }

  return children;
};

export default ModeratorRoute;
